import { render, staticRenderFns } from "./hdqSection.vue?vue&type=template&id=6ff98f0a&scoped=true"
import script from "./hdqSection.vue?vue&type=script&lang=js"
export * from "./hdqSection.vue?vue&type=script&lang=js"
import style0 from "./hdqSection.vue?vue&type=style&index=0&id=6ff98f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff98f0a",
  null
  
)

export default component.exports